module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showcounter) ? _c('div', {
    staticClass: "petition-counter"
  }, [_c('h2', [_c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": _vm.startcounter,
      "end-val": _vm.endcounter,
      "autoplay": false,
      "duration": 7000
    },
    on: {
      "callbackCounter": _vm.updatePercentage
    }
  })], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.countertitle))])]) : _vm._e(), _vm._v(" "), (_vm.showprogressbar) ? _c('div', {
    staticClass: "petition-progressbar"
  }, [_c('progressbar', {
    attrs: {
      "percentage": _vm.percentage,
      "revdirection": _vm.revdirection
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isActive) ? _c('div', {
    staticClass: "petition-form wwf-form light"
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('p', {
    staticClass: "form-intro"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', {
    staticClass: "form-intro"
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), (!_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('firstName')
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First name",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('first name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true}"
    }],
    class: {
      'border-red': _vm.errors.has('lastName')
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last name",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('last name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "with-input-loading"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionEmailIsValid: true,
        email: true
      }),
      expression: "{ required: true, petitionEmailIsValid: true, email: true }"
    }],
    class: {
      'border-red': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }, function($event) {
        _vm.onEmailInput()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('email')
      }
    }
  }), _vm._v(" "), (_vm.emailCheckSensis.checkEmailLoading) ? _c('div', {
    staticClass: "input-loading"
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3915/dist/assets/img/loading-tail-spin.svg"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('email')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('email')))]) : _vm._e()])]), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }],
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), (((_vm.country == 'Australia') ? 'number' : 'text') === 'checkbox' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.postCode) ? _vm._i(_vm.postCode, null) > -1 : (_vm.postCode)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        var $$a = _vm.postCode,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.postCode = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.postCode = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.postCode = $$c
        }
      }
    }
  }) : (((_vm.country == 'Australia') ? 'number' : 'text') === 'radio' && (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.postCode, null)
    },
    on: {
      "input": function($event) {
        _vm.postcodeUpdated()
      },
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      },
      "change": function($event) {
        _vm.postCode = null
      }
    }
  }) : (!_vm.hidepostcode && _vm.extraMandatoryFields.indexOf('postCode') > -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postCode),
      expression: "postCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPostCodeIsValid: true
      }),
      expression: "{ required: true, petitionPostCodeIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('postCode')
    },
    attrs: {
      "name": "postCode",
      "placeholder": "Postcode",
      "type": (_vm.country == 'Australia') ? 'number' : 'text'
    },
    domProps: {
      "value": (_vm.postCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.postCode = $event.target.value
      }, function($event) {
        _vm.postcodeUpdated()
      }],
      "focus": function($event) {
        _vm.logFirstTouch('postcode')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('postCode', 'petitionPostCodeIsValid') || _vm.errors.firstByRule('postCode')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('postCode')))]) : _vm._e()]), _vm._v(" "), (_vm.showphonenumber && _vm.extraMandatoryFields.indexOf('phoneNumber') == -1 && _vm.manatoryFields.indexOf('phoneNumber') == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }],
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showphonenumber && (_vm.extraMandatoryFields.indexOf('phoneNumber') > -1 || _vm.manatoryFields.indexOf('phoneNumber') > -1)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        petitionPhoneNumberIsValid: true
      }),
      expression: "{ required: true, petitionPhoneNumberIsValid: true }"
    }],
    class: {
      'border-red': _vm.errors.has('phoneNumber')
    },
    attrs: {
      "name": "phoneNumber",
      "type": "tel",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('phoneNumber', 'petitionPhoneNumberIsValid')) ? _c('p', [_vm._v(_vm._s(_vm.errors.first('phoneNumber')))]) : _vm._e()]), _vm._v(" "), (_vm.showstate) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "placeholder": "State"
    },
    on: {
      "focus": function($event) {
        _vm.logFirstTouch('state')
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACT"
    }
  }, [_vm._v("ACT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NSW"
    }
  }, [_vm._v("NSW")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NT"
    }
  }, [_vm._v("NT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QLD"
    }
  }, [_vm._v("QLD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TAS"
    }
  }, [_vm._v("TAS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIC"
    }
  }, [_vm._v("VIC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("WA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outside Australia"
    }
  }, [_vm._v("Outside Australia")])]) : _vm._e(), _vm._v(" "), (_vm.showrecipientslist && _vm.recipients != null) ? _c('div', {
    staticClass: "recipients-list"
  }, [_c('div', {
    staticClass: "recipients-title"
  }, [_vm._v("You will be contacting")]), _vm._v(" "), (_vm.recipients.mainMP) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.recipients.mainMP.salutation) + " " + _vm._s(_vm.recipients.mainMP.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length > 1) ? _c('div', {
    staticClass: "senators-list"
  }, [_c('div', [_vm._v("Select your Senator")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns senator-item"
  }, _vm._l((_vm.recipients.senators), function(senator) {
    return _c('label', {
      attrs: {
        "for": 'senator-' + senator.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedSenator),
        expression: "selectedSenator"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedSenator",
        "id": 'senator-' + senator.email
      },
      domProps: {
        "value": senator,
        "checked": _vm._q(_vm.selectedSenator, senator)
      },
      on: {
        "change": function($event) {
          _vm.selectedSenator = senator
        }
      }
    }), _vm._v("\n                     " + _vm._s(senator.salutation) + " " + _vm._s(senator.name) + "\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.senators.length === 1 && _vm.selectedSenator != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedSenator.salutation) + " " + _vm._s(_vm.selectedSenator.name))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length > 1) ? _c('div', {
    staticClass: "mps-list"
  }, [_c('div', [_vm._v("Select your MP")]), _vm._v(" "), _c('div', {
    staticClass: "wwf-radio-bttns mp-item"
  }, _vm._l((_vm.recipients.mps), function(mp) {
    return _c('label', {
      attrs: {
        "for": 'mp-' + mp.email
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedMP),
        expression: "selectedMP"
      }],
      attrs: {
        "type": "radio",
        "name": "selectedMP",
        "id": 'mp-' + mp.email
      },
      domProps: {
        "value": mp,
        "checked": _vm._q(_vm.selectedMP, mp)
      },
      on: {
        "change": function($event) {
          _vm.selectedMP = mp
        }
      }
    }), _vm._v("\n                     " + _vm._s(mp.salutation) + " " + _vm._s(mp.name) + ", MP\n                     "), _c('span', {
      staticClass: "wwf-radio"
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.recipients.mps.length === 1 && _vm.selectedMP != null) ? _c('div', {
    staticClass: "recipient"
  }, [_vm._v("• " + _vm._s(_vm.selectedMP.salutation) + " " + _vm._s(_vm.selectedMP.name) + ", MP")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "placeholder": _vm.messageplaceholder,
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showmessage) ? _c('p', {
    staticClass: "word-count"
  }, [_vm._v(_vm._s(255 - (_vm.message ? _vm.message.length : 0) + ' Char'))]) : _vm._e(), _vm._v(" "), (_vm.showcountry) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('country')
    },
    attrs: {
      "name": "country",
      "autocomplete": "country",
      "placeholder": "Country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('option', {
      domProps: {
        "value": countries.name
      }
    }, [_vm._v(_vm._s(countries.name))])
  })) : _vm._e(), _vm._v(" "), (_vm.seeMessageButtonBottom) ? _c('input', {
    staticClass: "read-letter",
    attrs: {
      "type": "button",
      "value": "Here's the message we're sending"
    },
    on: {
      "click": _vm.openReadLetterPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showpermission) ? _c('div', [_vm._v("\n                 Do you give permission for your submission to be published on the EPBC Act Review website?"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionyes",
      "id": "permissionyes",
      "value": "Yes"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Yes")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionyes"
    }
  }, [_vm._v("Yes – with my name")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionanonymous",
      "id": "permissionanonymous",
      "value": "Anonymous"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "Anonymous")
    },
    on: {
      "change": function($event) {
        _vm.permission = "Anonymous"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionanonymous"
    }
  }, [_vm._v("Yes – anonymously ")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.permission),
      expression: "permission"
    }],
    class: {
      'border-red': _vm.errors.has('permissionyes')
    },
    attrs: {
      "type": "radio",
      "name": "permissionno",
      "id": "permissionno",
      "value": "No"
    },
    domProps: {
      "checked": _vm._q(_vm.permission, "No")
    },
    on: {
      "change": function($event) {
        _vm.permission = "No"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "permissionno"
    }
  }, [_vm._v("No – please keep my submission confidential")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getextracampaignsList), function(extracampaign, index) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCampaign),
        expression: "selectedCampaign"
      }],
      attrs: {
        "type": "checkbox",
        "name": 'extracampaign' + index,
        "id": 'extracampaign' + index
      },
      domProps: {
        "value": extracampaign,
        "checked": Array.isArray(_vm.selectedCampaign) ? _vm._i(_vm.selectedCampaign, extracampaign) > -1 : (_vm.selectedCampaign)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCampaign,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = extracampaign,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCampaign = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCampaign = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCampaign = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'extracampaign' + index
      }
    }, [_vm._v("Add my name to " + _vm._s(extracampaign.title) + " too!")])])
  }), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('input', {
    staticClass: "btn-submit",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "value": _vm.isSaving ? 'Loading...' : 'Submit'
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isProfanity),
      expression: "isProfanity"
    }],
    staticClass: "alert-box"
  }, [_vm._v("No bad words! Please change your message.")])], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('div', {
    staticClass: "form-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.closingmessage))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-statement"
  }, [_c('p', [_vm._v("By signing you accept\n               "), _c('a', {
    attrs: {
      "href": "/privacy-policy/privacy-policy",
      "target": "_blank"
    }
  }, [_vm._v("WWF-Australia’s Privacy Policy.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa06f2d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=tqk19250jg!./~/string-replace-webpack-plugin/loader.js?id=bvfl15s0ypr!./src/components/PetitionForm.vue
// module id = 720
// module chunks = 0